import colorMap from './colorMap'


/*  For Reference
var color = {
    CLETPUS: colorMap['coal'], //Coal
    PAETPUS: colorMap['petroleum'], //Petroleum
    NGETPUS: colorMap['naturalGas'], //Natural Gas
    OJETPUS: colorMap['otherGas'], //Other Gases
    NUETPUS: colorMap['nuclear'], //Nuclear
    HPETPUS: colorMap['hydroPumped'], //Hydroelectric Pumped Storage
    HVETPUS: colorMap['hydroConventional'], //Conventional Hydroelectric Power
    WDETPUS: colorMap['wood'], //Wood
    WSETPUS: colorMap['waste'], //Waste
    GEETPUS: colorMap['geothermal'], //Geothermal
    SOETPUS: colorMap['solar'], //Solar
    WYETPUS: colorMap['wind'], //Wind
};
*/

export const waypoints = [
    {
        id: 0,
        textBoxDescription: "After the end of the Second World War, growing suburbinzation and increased demand led to the expansion of coal supplying the country with over 50% of its electrical power generation beginning in 1954.",
        textBoxTitle: "1954",
        textBoxColor: colorMap['coal'],
        citation: "http://americanhistory.si.edu/powering/past/history2.htm",
        correspondingVis: 1,
        annotations: [{
            type: "bounds",
            YYYYMM: "01/01/1954",
            bounds: [{ YYYYMM: new Date("1/1/1954") }, { YYYYMM: new Date("1/1/1960") }],
            label: "Coal Dominates Power Production",
            color: colorMap['coal'],
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "The Organization of the Petroleum Exporting Countries (OPEC) enacted an embargo on the United States. In response gas shortages occured across the US and citizens began rationing fuel to conserve use. The 1973 Oil Crisis displayed the United State's reliance on foreign energy.",
        textBoxTitle: "1973",
        textBoxColor: colorMap['petroleum'],
        citation: "http://sites.utexas.edu/energyinstitute/files/2016/09/UTAustin_FCe_History_2016.pdf https://thebreakthrough.org/index.php/programs/energy-and-climate/gas-driven-carbon-reductions-point-to-new-climate-paradigm",
        correspondingVis: 1,
        annotations: [{
          type: "x",
          note: {label: "OPEC Embargo Causes Oil Crisis", align: "middle"},
          YYYYMM: "1/1/1973",
          color: colorMap['petroleum'],
          dy: -10,
          dx: 350,
          connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "Passed during the energy crises caused by OPEC's embargo, The Powerplant and Industrial Fuel Use Act (PIFUA), was designed to increase the use of coal and other alternate fuels as primary energy sources for baseload* power generation.",
        textBoxTitle: "1978",
        textBoxColor: colorMap['coal'],
        citation: "http://heinonline.org/HOL/LandingPage?handle=hein.journals/helr3&div=12&id=&page=",
        correspondingVis: 1,
        annotations: [{
            type: "x",
            YYYYMM: "01/01/1978",
            note: {label: "The Powerplant and Industrial Fuel Use Act (PIFUA)"},
            color: colorMap['coal'],
            dy: -10,
            dx: 50,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "In the same year, the Natural Gas Policy Act (NGPA) started the process of phasing out regulations on gas wellhead prices. Over the next ten years, advances in natural gas technology eventually led to greater availability and lower prices.",
        textBoxTitle: "1978",
        textBoxColor: colorMap['naturalGas'],
        citation: "http://sites.utexas.edu/energyinstitute/files/2016/09/UTAustin_FCe_History_2016.pdf",
        correspondingVis: 1,
        annotations: [{
            type: "x",
            YYYYMM: "01/01/1978",
            note: {label: "Petroleum is Energy Leader", align: "middle"},
            color: colorMap['naturalGas'],
            dy: -10,
            dx: 50,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "Beginning in 1985, a series of orders by the Federal Energy Regulatory Commission (FERC) further supported the growth of the natural gas market.",
        textBoxTitle: "1985",
        textBoxColor: colorMap['naturalGas'],
        // citation: "https://alternativeenergy.procon.org/view.timeline.php?timelineID=000015#1951-1999",
        correspondingVis: 1,
        annotations: [{
            type: "x",
            YYYYMM: "01/01/1985",
            note: {label: "FERC Acts", align: "middle"},
            color: colorMap['natural gas'],
            dy: -10,
            dx: 50,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "In 1999, heightened awairness in US cities and states led to a petition to persuade the Environmental Protection Agency (EPA) to take action in reducing greenhouse gases. However later in 2003, the EPA asserted that it did not possess the authority to regulate greenhouse gases and that even if the agency did, it would not exercise it.",
        textBoxTitle: "1999 - 2003",
        textBoxColor: colorMap['coal'],
        citation: "https://thebreakthrough.org/index.php/programs/energy-and-climate/making-fossil-fuels-irrelevant",
        correspondingVis: 1,
        annotations: [{
            type: "bounds",
            YYYYMM: "01/01/1999",
            bounds: [{ YYYYMM: new Date("1/1/1999") }, { YYYYMM: new Date("1/1/2003") }],
            label: "Climate Change Fears Arise",
            color: colorMap['coal'],
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "With increased oil prices, many of the oil-fired peak capacity generators responsible for handling high demand were swtiched to natural gas.",
        textBoxTitle: "2007",
        textBoxColor: colorMap['naturalGas'],
        correspondingVis: 1,
        citation: "https://thebreakthrough.org/index.php/programs/energy-and-climate/gas-driven-carbon-reductions-point-to-new-climate-paradigm",
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2007",
            note: {label: "Natural Gas Prices Reduce Greatly", align: "middle"},
            color: colorMap['naturalGas'],
            dy: -10,
            dx: 50,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "During the 2008 recession coal was hit especially hard. In addtion the US unemployment rate rose from 4.7% in November 2007 to peak at 10% in October 2009",
        textBoxTitle: "2008",
        textBoxColor: colorMap['coal'],
        correspondingVis: 1,
        citation: "https://fred.stlouisfed.org/series/UNRATE",
        annotations: [{
            type: "bounds",
            YYYYMM: "1/1/2008",
            bounds: [{ YYYYMM: new Date("1/1/2007") }, { YYYYMM: new Date("1/1/2009") }],
            label: "2008 Great Recession",
            color: colorMap['coal'],
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "Here, things start to get interesting. In order to understand why coal begins to decline, let's take a closer look at how coal energy production has changed over the past two decades.",
        textBoxTitle: "",
        textBoxColor: colorMap['coal'],
        correspondingVis: 1,
        annotations: [{
            type: "bounds",
            YYYYMM: "1/1/2008",
            bounds: [{ YYYYMM: new Date("1/1/2001") }, { YYYYMM: new Date("1/1/2016") }],
            label: "What Happened?",
            color: colorMap['coal'],
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },

    // Transition to Map ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
        id: 0,
        textBoxDescription: "Coal-fired power plants largely dominated the landscape, when compared to natural gas plants.",
        textBoxTitle: "2001",
        textBoxColor: colorMap['naturalGas'],
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2001",
            color: colorMap['naturalGas'],
            note: {label: "Coal plants largely dominate landscape", align: "middle"},
            dy: -10,
            dx: 0,
            connector: {end: "none"},
            annotationSettings: {strokeWidth: 5}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2002",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2002",
            note: {label: "2002", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2003",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2003",
            note: {label: "2003", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2004",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2004",
            note: {label: "2004", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2005",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2005",
            note: {label: "2005", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2006",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2006",
            note: {label: "2006", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2007",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2007",
            note: {label: "2007", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "Throughout the early 2000's, advances in hydraulic fracturing (fracking) and drilling allowed for natural gas to be harvested from deep in shale deposits. As a result of new shale gas discoveries, estimates for US natural gas supply were 35% higher than in 2006–anew source of cheap, abundant natural gas.",
        textBoxTitle: "2008",
        textBoxColor: colorMap['naturalGas'],
        correspondingVis: 4,
        citation: "http://www.nytimes.com/2009/06/18/business/energy-environment/18gas.html",
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2008",
            note: {label: "Shale Hydraulic Fracturing", align: "right"},
            color: colorMap['naturalGas'],
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "The 2008 recession crippled demand for energy from all sectors. Coal was hit especially hard, falling 8.5% in 2009 to 1.07 billion tons, \"the largest percentage decline since 1958 and the biggest tonnage drop-off since 1949,\" according to the Energy Information Administration (EIA). Much of the decline was caused by weak industrial demand for electricity and low gas prices. Utilities and power generators began using more of this cheap gas to produce power.",
        textBoxTitle: "2008",
        textBoxColor: colorMap['coal'],
        correspondingVis: 4,
        citation: "http://www.nbcnews.com/id/36199456/ns/business-oil_and_energy/t/tough-times-us-coal-industry/#.WpXJLxPwZmA",
        annotations: [{
            type: "bounds",
            YYYYMM: "1/1/2008",
            note: {label: "2008 Great Recession Hurts Coal", align: "right"},
            bounds: [{ YYYYMM: new Date("1/1/2008") }, { YYYYMM: new Date("1/1/2010") }],
            color: colorMap['coal'],
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2009",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2009",
            note: {label: "2009", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2010",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2010",
            note: {label: "2010", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2011",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2011",
            note: {label: "2011", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2012",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2012",
            note: {label: "2012", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2013",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2013",
            note: {label: "2013", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "The EPA introduced the Clean Power Plan. Officially finalized by the Obama administration in 2015, the plan focused on increasing existing plant efficiency, suplementing natural gas for coal to reduce emmissions and transitioning to renewable sources from fossil fuels.",
        textBoxTitle: "2014",
        textBoxColor: colorMap['naturalGas'],
        citation: "https://en.wikipedia.org/wiki/Clean_Power_Plan",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2014",
            color: colorMap['naturalGas'],
            label: "Clean Power Plan",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "",
        textBoxTitle: "2015",
        textBoxColor: "grey",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2015",
            note: {label: "2015", align: "right"},
            color: "grey",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "While coal advocates blame the Clean Power Plan (CPP) for waging the war on coal, the EIA says that natural gas and renewables would have claimed a large market share from coal regardless of the CPP–many experts claim that coal is dying regardless of EPA regulations. The market forces at play make opening new coal plants financially unviable.",
        textBoxTitle: "2016",
        textBoxColor: colorMap['coal'],
        citation: "http://time.com/coals-last-kick/",
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2016",
            color: colorMap['coal'],
            note: {label: "2016", align: "right"},
            dy: -10,
            dx: 0,
            connector: {end: "none"},
        }]
    },
    {
        id: 0,
        textBoxDescription: "What does this mean for jobs?",
        textBoxTitle: "",
        textBoxColor: colorMap['coal'],
        correspondingVis: 4,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2015",
            color: colorMap['coal'],
            label: "Jobs?",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },

    // Transition to Employment ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
        id: 0,
        textBoxDescription: "Beginning in 2012, two years before the introduction of the CPP, the United States workforce of coal miners began declining from a high of almost 90,000 workers. By 2016, the workforce had declined over 50%, having the largest impact in West Virginia and other states that are heavily investing in coal mining.",
        textBoxTitle: "2012",
        textBoxColor: colorMap['coal'],
        correspondingVis: 3,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2014",
            color: colorMap['coal'],
            label: "Clean Power Plan",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "Trump began the process of repealing the CPP, and announced that he added 45,000 jobs in the coal sector, however the Bureau of Labor Statistics shows a much smaller increase of just a few thousand.",
        textBoxTitle: "2017",
        textBoxColor: colorMap['coal'],
        citation: "http://www.newsweek.com/donald-trump-has-only-delivered-1200-coal-mining-jobs-despite-claiming-have-751885",
        correspondingVis: 3,
        annotations: [{
            type: "x",
            YYYYMM: "1/1/2017",
            color: colorMap['coal'],
            label: "Trump repeals the CPP",
            dy: -10,
            dx: 0,
            connector: {end: "none"}
        }]
    },
    {
        id: 0,
        textBoxDescription: "Despite a bleak forcast for current coal mining employees, opportunities in the gas and renewable sectors may provide other employment opportunities moving forward. The U.S. Department of Energy projects that the wind energy sector will employ 600,000 employees by 2050.",
        textBoxTitle: "2050",
        textBoxColor: colorMap['wind'],
        citation: "https://energy.gov/eere/articles/wind-energy-supporting-600000-jobs-2050",
        correspondingVis: 3,
        annotations: []
    },
    {
        id: 0,
        textBoxDescription: "Finally, let's take a look at one last piece of the puzzle. Can coal really be \"clean\"?",
        textBoxTitle: "",
        textBoxColor: colorMap['coal'],
        correspondingVis: 3,
        annotations: []
    },


// Transition to Environment ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
        id: 0,
        textBoxDescription: "When assessing the effects of different energy sources on our environment, it's important to understand that different greenhouses gases have different potencies. The Intergovernmental Panel on Climate Change's (IPCC) assesses the total global warming potential (GWP) of each energy type in terms of their CO2 equivalent effects.",
        textBoxTitle: "",
        textBoxColor: colorMap['coal'],
        correspondingVis: 2,
        annotations: []
    },
    {
        id: 0,
        textBoxDescription: "Comparing these GWP's, we can see that coal has by far the biggest impact on our climate. It is objectively the least \"clean\" energy source according to the IPCC.",
        textBoxTitle: "",
        textBoxColor: colorMap['coal'],
        correspondingVis: 2,
        annotations: []
    },
    {
        id: 0,
        textBoxDescription: "So is there any way to make coal clean? Carbon capture and storage/sequestration (CCS) is the technology usually associated with \"clean coal.\" The various strategies for CCS could reduce coal emissions by as much as 75% acording to the IPCC. But in his 2018 budget proposal, Trump proposed cutting CCS funding by 55%. In 2019, he proposes to a 20% cut compared to 2016. Only time will tell if this new technology really helps to revitalize coal, however in the absense of serious and substantial CCS funding, \"clean coal\" appears to be an oxymoron.",
        textBoxTitle: "",
        textBoxColor: colorMap['coal'],
        citation: "https://www.washingtonpost.com/politics/2018/live-updates/trump-white-house/fact-checking-and-analysis-of-trumps-state-of-the-union-2018-address/about-that-war-on-beautiful-clean-coal/?utm_term=.40805d66257a",
        correspondingVis: 2,
        annotations: []
    },
    {
        id: 0,
        textBoxDescription: "While natural gas is still a fossil fuel and is by no means a \"clean\" energy source, watt-for-watt it does produce roughly 40% less atmospheric warming.",
        textBoxTitle: "",
        textBoxColor: colorMap['naturalGas'],
        correspondingVis: 2,
        annotations: []
    },
    {
        id: 0,
        textBoxDescription: "While cheap natural gas means competition for all forms of energy, many energy researchers believe that natural gas is largely replacing coal, not competiting with renewables and other low carbon sources, such as nuclear. Evidence shows that while renewables are typcially credited with reducing emissions, the switch from coal to natural gas may actually be responsible for the decline in U.S. emmissions.",
        textBoxTitle: "",
        textBoxColor: colorMap['naturalGas'],
        citation: "https://thebreakthrough.org/index.php/issues/natural-gas/natural-gas-overwhelmingly-replaces-coal",
        correspondingVis: 2,
        annotations: []
    },
]



// WEBPACK FOOTER //
// ./src/Waypoints.js